export default {
  nav: {
    home: 'Home',
    about: 'The House',
    gallery: 'Gallery',
    booking: 'Booking',
    contact: 'Contact',
  },
  hero: {
    title: 'Your Holiday Home at the North Sea',
    subtitle: 'Relaxing days in Dornumersiel - where dike, mudflats and sea meet',
    ctaPrimary: 'Book now',
    ctaSecondary: 'Learn more',
  },
  about: {
    title: 'Welcome to Your Holiday Home',
    description1: 'Our charming holiday home in Dornumersiel offers the perfect retreat for relaxing days on the North Sea coast. Surrounded by the unique nature of the UNESCO World Heritage Wadden Sea, you will find peace and relaxation here.',
    description2: 'The house has modern equipment with a cozy ambience. Enjoy long walks on the dike, mudflat walks at low tide or simply the fresh sea air on the terrace.',
    badge: 'North Sea Coast',
    guests: 'Up to 6 guests',
    bedrooms: '3 bedrooms',
    bathrooms: '2 bathrooms',
    pets: 'Pets welcome',
  },
  features: {
    title: 'Amenities & Highlights',
    subtitle: 'Everything you need for a perfect holiday',
    items: {
      wifi: {
        title: 'WiFi',
        description: 'High-speed internet throughout the house',
      },
      parking: {
        title: 'Parking',
        description: 'Free parking space right at the house',
      },
      kitchen: {
        title: 'Fully equipped kitchen',
        description: 'Incl. dishwasher, fridge & oven',
      },
      terrace: {
        title: 'Sun terrace',
        description: 'With garden furniture & BBQ',
      },
      heating: {
        title: 'Underfloor heating',
        description: 'Cozy warmth even in off-season',
      },
      tv: {
        title: 'Smart TV',
        description: 'Streaming services for cozy evenings',
      },
      washing: {
        title: 'Washing machine',
        description: 'Incl. dryer in utility room',
      },
      bike: {
        title: 'Bike rental',
        description: 'Bikes can be rented on site',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Let our holiday home enchant you',
    altExterior: 'Exterior view of the holiday home',
    altLiving: 'Cozy living room',
    altKitchen: 'Modern kitchen',
    altBedroom: 'Bright bedroom',
    altBathroom: 'Modern bathroom',
    altTerrace: 'Sunny terrace',
    altBeach: 'North Sea beach nearby',
    altDike: 'Dike landscape Dornumersiel',
    altHarbor: 'Harbor of Dornumersiel',
    altNature: 'Mudflats and nature',
  },
  location: {
    title: 'Location & Surroundings',
    subtitle: 'Dornumersiel - Your gateway to the Wadden Sea',
    description: 'The holiday home is located in picturesque Dornumersiel, an idyllic coastal village in the heart of East Frisia. The North Sea beach, the picturesque harbor and countless cycling and hiking trails along the dike are right on your doorstep.',
    distanceBeach: '5 min. to beach',
    distanceHarbor: '3 min. to harbor',
    distanceTown: '10 min. to Dornum',
    distanceWadden: 'Directly at Wadden Sea',
  },
  booking: {
    title: 'Book online',
    subtitle: 'Reserve your holiday directly online',
    description: 'You can also book our holiday home via this platform. Simply select your desired dates and submit your request.',
    iframePlaceholder: 'Booking system loading...',
    externalCta: 'Also book on Vrbo',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Questions? We are here for you!',
    form: {
      nameLabel: 'Your name',
      namePlaceholder: 'John Doe',
      emailLabel: 'Email address',
      emailPlaceholder: 'john@example.com',
      phoneLabel: 'Phone (optional)',
      phonePlaceholder: '+1 234 567 890',
      messageLabel: 'Your message',
      messagePlaceholder: 'Your inquiry or message to us...',
      submit: 'Send message',
      success: 'Thank you! Your message has been sent successfully.',
      error: 'An error occurred. Please try again later.',
      privacyHint: 'By submitting, you agree to our privacy policy.',
    },
    info: {
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      addressValue: 'Musterstraße 1, 26553 Dornumersiel',
      availability: 'Availability',
      availabilityValue: 'Mon - Fri: 9:00 - 18:00',
    },
  },
  footer: {
    rights: 'All rights reserved',
    impressum: 'Legal Notice',
    datenschutz: 'Privacy Policy',
    backToTop: 'Back to top',
    madeWith: 'Made with love in Dornumersiel',
  },
  notFound: {
    title: 'Page not found',
    description: 'The requested page could not be found.',
    backHome: 'Back to homepage',
  },
};